import {store} from './../../redux/';
import { call, put } from 'redux-saga/effects';
import { url } from './../../services/Url';
import CONSTANTS from '../../util/constants';
import APICallingService from '../../services/APICallingService';

const getContainersAPI = (action) => {
    let containerUrl;
    if (action.searchText && action.searchText != null) {
        containerUrl = url.getContainers + "/" + action.searchText + "/" + action.pageNo + "/" + 100;
    }
    else {
        containerUrl = url.getContainers + "/" + action.pageNo + "/" + 100;
    }
    return APICallingService.sendRequestForGet(containerUrl, (res) => {
    }, true);
}

function* getContainers(action) {
    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getContainersAPI, action.payload.value);

        if (response && response != null) {
            yield put({
                type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_CONTAINERS_API_SUCCESS, payload: { value: response.data }
            })
            yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: false } });

        }
        else {
            alert('Failed to get container');
            yield put({
                type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_CONTAINERS_API_SUCCESS, payload: { value: 'Failed' }
            })
        }
    }
    catch (e) {
        yield put({
            type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_CONTAINERS_API_SUCCESS, payload: { value: 'Failed' }
        })
    }
}

export { getContainers };
